import(/* webpackMode: "eager", webpackExports: ["AuthError"] */ "/home/vsts/work/1/s/libs/event-management/ui/src/lib/auth-error/AuthError.tsx");
